import React, { memo } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

const geoUrl = "https://unpkg.com/world-atlas@2.0.2/countries-110m.json";

const NUMERIC_TO_ISO3 = {
  "004":"AFG","008":"ALB","010":"ATA","012":"DZA","024":"AGO",
  "031":"AZE","032":"ARG","036":"AUS","040":"AUT","044":"BHS",
  "050":"BGD","051":"ARM","056":"BEL","064":"BTN","068":"BOL",
  "070":"BIH","072":"BWA","076":"BRA","084":"BLZ","090":"SLB",
  "096":"BRN","100":"BGR","104":"MMR","108":"BDI","112":"BLR",
  "116":"KHM","120":"CMR","124":"CAN","140":"CAF","144":"LKA",
  "148":"TCD","152":"CHL","156":"CHN","158":"TWN","170":"COL",
  "178":"COG","180":"COD","188":"CRI","191":"HRV","192":"CUB",
  "196":"CYP","203":"CZE","204":"BEN","208":"DNK","214":"DOM",
  "218":"ECU","222":"SLV","226":"GNQ","231":"ETH","232":"ERI",
  "233":"EST","238":"FLK","242":"FJI","246":"FIN","250":"FRA",
  "260":"ATF","262":"DJI","266":"GAB","268":"GEO","270":"GMB",
  "275":"PSE","276":"DEU","288":"GHA","300":"GRC","304":"GRL",
  "320":"GTM","324":"GIN","328":"GUY","332":"HTI","340":"HND",
  "348":"HUN","352":"ISL","356":"IND","360":"IDN","364":"IRN",
  "368":"IRQ","372":"IRL","376":"ISR","380":"ITA","388":"JAM",
  "392":"JPN","398":"KAZ","400":"JOR","404":"KEN","408":"PRK",
  "410":"KOR","414":"KWT","417":"KGZ","418":"LAO","422":"LBN",
  "426":"LSO","428":"LVA","430":"LBR","434":"LBY","440":"LTU",
  "442":"LUX","450":"MDG","454":"MWI","458":"MYS","466":"MLI",
  "478":"MRT","484":"MEX","496":"MNG","498":"MDA","499":"MNE",
  "504":"MAR","508":"MOZ","512":"OMN","516":"NAM","524":"NPL",
  "528":"NLD","540":"NCL","548":"VUT","554":"NZL","558":"NIC",
  "562":"NER","566":"NGA","578":"NOR","586":"PAK","591":"PAN",
  "598":"PNG","600":"PRY","604":"PER","608":"PHL","616":"POL",
  "620":"PRT","624":"GNB","626":"TLS","630":"PRI","634":"QAT",
  "642":"ROU","643":"RUS","646":"RWA","682":"SAU","686":"SEN",
  "688":"SRB","694":"SLE","700":"SGP","703":"SVK","704":"VNM",
  "705":"SVN","706":"SOM","710":"ZAF","716":"ZWE","724":"ESP",
  "728":"SSD","729":"SDN","732":"ESH","740":"SUR","748":"SWZ",
  "752":"SWE","756":"CHE","760":"SYR","762":"TJK","764":"THA",
  "768":"TGO","780":"TTO","784":"ARE","788":"TUN","792":"TUR",
  "795":"TKM","800":"UGA","804":"UKR","807":"MKD","818":"EGY",
  "826":"GBR","834":"TZA","840":"USA","854":"BFA","858":"URY",
  "860":"UZB","862":"VEN","887":"YEM","894":"ZMB"
};

const ISO2_TO_ISO3 = {
  AF:"AFG", AL:"ALB", DZ:"DZA", AO:"AGO", AR:"ARG", AM:"ARM",
  AU:"AUS", AT:"AUT", AZ:"AZE", BD:"BGD", BY:"BLR", BE:"BEL",
  BO:"BOL", BA:"BIH", BW:"BWA", BR:"BRA", BG:"BGR", KH:"KHM",
  CM:"CMR", CA:"CAN", CL:"CHL", CN:"CHN", CO:"COL", CR:"CRI",
  HR:"HRV", CU:"CUB", CY:"CYP", CZ:"CZE", DK:"DNK", DO:"DOM",
  EC:"ECU", EG:"EGY", SV:"SLV", EE:"EST", ET:"ETH", FI:"FIN",
  FR:"FRA", GE:"GEO", DE:"DEU", GH:"GHA", GR:"GRC", GT:"GTM",
  HN:"HND", HU:"HUN", IS:"ISL", IN:"IND", ID:"IDN", IR:"IRN",
  IQ:"IRQ", IE:"IRL", IL:"ISR", IT:"ITA", JP:"JPN", JO:"JOR",
  KZ:"KAZ", KE:"KEN", KW:"KWT", KG:"KGZ", LV:"LVA", LB:"LBN",
  LT:"LTU", LU:"LUX", MG:"MDG", MY:"MYS", MX:"MEX", MD:"MDA",
  MN:"MNG", ME:"MNE", MA:"MAR", MZ:"MOZ", MM:"MMR", NA:"NAM",
  NP:"NPL", NL:"NLD", NZ:"NZL", NI:"NIC", NG:"NGA", NO:"NOR",
  OM:"OMN", PK:"PAK", PA:"PAN", PY:"PRY", PE:"PER", PH:"PHL",
  PL:"POL", PT:"PRT", QA:"QAT", RO:"ROU", RU:"RUS", RW:"RWA",
  SA:"SAU", SN:"SEN", RS:"SRB", SG:"SGP", SK:"SVK", SI:"SVN",
  SO:"SOM", ZA:"ZAF", ES:"ESP", LK:"LKA", SE:"SWE", CH:"CHE",
  SY:"SYR", TH:"THA", TN:"TUN", TR:"TUR", UA:"UKR", AE:"ARE",
  GB:"GBR", US:"USA", UY:"URY", UZ:"UZB", VE:"VEN", VN:"VNM",
  YE:"YEM", ZM:"ZMB", ZW:"ZWE"
};

const MerchMapSVG = memo(({ countryCode, ownedCountries = [] }) => {

  const converted = ownedCountries.map(c => ISO2_TO_ISO3[c] || c);

  return (
    <ComposableMap
      projection="geoEqualEarth"
      projectionConfig={{ scale: 150, center: [0, 0] }}
      width={800}
      height={400}
      style={{ width: "100%", height: "100%", pointerEvents: "none" }}
    >
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies.map((geo) => {

          const iso3 = NUMERIC_TO_ISO3[geo.id];

const isSelected = converted.includes(iso3);

            const style = {
              fill: isSelected ? "#FFD700" : "transparent",
              stroke: "#FFD700",
              strokeWidth: isSelected ? 1.4 : 0.6,
              outline: "none",
              filter: isSelected ? "drop-shadow(0 0 3px #FFD700)" : "none"
            };

            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                tabIndex={-1}
                style={{ default: style, hover: style, pressed: style }}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
});

export default MerchMapSVG;
